import { Injectable } from '@angular/core';
import { OfferData } from 'projects/visa-platform/src/app/shared/interfaces';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RedemptionService {
  public offerDetails?: OfferData;
  public merchantLogo?: string;
  public merchantName?: string;
  public modalHeading?: string;
  public voucherCode?: string;
  public voucherDescription?: string;
  public voucherTitle?: string;
  public validityDate?: string;
  public eligibilityRenewalId?: string;

  private redemptionModalVisible = new BehaviorSubject<boolean>(false);
  public redemptionModalVisible$ = this.redemptionModalVisible.asObservable();
  private termsModalVisible = new BehaviorSubject<boolean>(false);
  public termsModalVisible$ = this.termsModalVisible.asObservable();
  private refreshDetails = new Subject<void>();
  public refreshDetails$ = this.refreshDetails.asObservable();

  private emailVerifyVisible = new BehaviorSubject<boolean>(false);
  public emailVerifyVisible$ = this.emailVerifyVisible.asObservable();

  public showRedemptionModal(
    offerDetails: OfferData | undefined,
    logo: string | undefined,
    name: string | undefined,
    heading: string | undefined,
    voucherCode: string | undefined,
    eligibilityRenewalId?: string
  ): void {
    this.redemptionModalVisible.next(true);
    this.offerDetails = offerDetails;
    this.merchantLogo = logo;
    this.merchantName = name;
    this.modalHeading = heading;
    this.voucherCode = voucherCode;
    this.eligibilityRenewalId = eligibilityRenewalId;
  }

  public hideRedemptionModal(): void {
    this.redemptionModalVisible.next(false);
  }

  public showTermsModal(): void {
    this.termsModalVisible.next(true);
  }

  public hideTermsModal(): void {
    this.termsModalVisible.next(false);
  }

  public triggerRefreshDetails(): void {
    this.refreshDetails.next();
  }

  public showEmailVerifyModal(
    offerDetails: OfferData | undefined,
    logo: string,
    name: string,
    description: string,
    title: string,
    validityDate: string,
    eligibilityRenewalId: string
  ): void {
    this.emailVerifyVisible.next(true);
    this.offerDetails = offerDetails;
    this.merchantLogo = logo;
    this.merchantName = name;
    this.voucherDescription = description;
    this.voucherTitle = title;
    this.validityDate = validityDate;
    this.eligibilityRenewalId = eligibilityRenewalId;
  }

  public hideEmailVerifyModal(): void {
    this.emailVerifyVisible.next(false);
  }
}
